import React from "react";
import { Flex } from 'reflexbox'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { Checkbox } from 'react-toolbox/lib/checkbox'
import Pie from 'components/custom/Highcharts/Pie'

import {
  updateProjectCountsQueryAction
} from '../actions'
import {
  lifecyclesEnum
} from '../constants'
import {
  projectCountsQuerySelector,
} from '../selectors'
import styles from '../styles.scss'

const mapStateToProps = (state) => {
  return {
    projectCountsQuery: projectCountsQuerySelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateProjectCountsQueryAction: (lifecycles) => dispatch(updateProjectCountsQueryAction(lifecycles)),
  }
}

class ProjectCountsChart extends React.Component {
  render() {
    const {
      report,
      projectCountsQuery,
      updateProjectCountsQueryAction
    } = this.props

    const handleChange = (field, isChecked) => {
      let newQuery = [...projectCountsQuery]
      if (isChecked) {
        newQuery.push(field)
      } else {
        const index = newQuery.findIndex(lifecycle => lifecycle === field)
        newQuery.splice(index, 1)
      }
      updateProjectCountsQueryAction(newQuery)
    }

    const total = report.data.reduce((count, newVal) => {
      return count + newVal.y
    }, 0)

    return (
      <React.Fragment>
        <Pie
          title={`${report.title}: ${total} Projects`}
          data={report.data}
        />
        <Flex row='true' wrap>
          {Object.values(lifecyclesEnum).map((lifecycle) => (
            <Checkbox
              styleName='checkboxes'
              key={lifecycle.label}
              label={lifecycle.label}
              checked={projectCountsQuery.includes(lifecycle.value)}
              onChange={handleChange.bind(this, lifecycle.value)}
            />
          ))}
        </Flex>
      </React.Fragment>
    );
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(ProjectCountsChart)
